import { Align } from "../../../../common/TextUtils"
import { PhaserText } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { PersonalityAtlas } from "../PersonalityAssets"

export const personalityLoadingBar = (game: Phaser.Game, description: string, onComplete: () => void) => {

    const group = game.add.group()
    PhaserText.create(game, description, {
        wordWrapWidth: 0.65,
        centerInWorldXOnly: true,
        y: Scale.y(0.35),
        align: Align.CENTER,
        group
    })

    const searchingBar = Sprites.add(game, PersonalityAtlas.SEARCHING, {group})
    Sprites.centerInWorld(searchingBar)
    searchingBar.animations.add(PersonalityAtlas.SEARCHING, undefined, 9)
    Sprites.playAnimationNTimes(searchingBar, PersonalityAtlas.SEARCHING, 1,
        () => {
            group.destroy(true)
            onComplete()
        }
    )
}